<div class="flex py-4 text-sm tk-bg-nero">
  <button class="ml-6 flex items-center cursor-pointer tk-c-gray-4 hover:text-white" (click)="onCopyLink()">
    <!-- <sm-copy-to-clipboard classes="w-4 h-4  mr-2"></sm-copy-to-clipboard> -->
    <i class="bi bi-copy mr-2"></i>
    <div>{{'handover.copy-link' | translate}}</div>
  </button>

  <button class="ml-6 flex items-center cursor-pointer tk-c-gray-4 hover:text-white" (click)="onPrint()">
    <i class="bi bi-printer mr-2"></i>
    <div class="">{{'handover.print-handover' | translate}}</div>
  </button>
</div>
